<template>
  <NuxtLayout> 
    <NuxtPage></NuxtPage>
  </NuxtLayout>
</template>

<style lang="css">
</style>
